import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import Checklogin from "../middleware/Checklogin";
import Delete from "../components/Delete";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import server from "../Config";
import { useSelector } from "react-redux";

const Languages = () => {

    const [data, setData] = useState([{}]);
    const [del, setDel] = useState("");
    const trash = useSelector((state) => state.appState.delete[0]);


     const submit = (id) => {
      confirmAlert({
        title: 'Confirm to Delete id:'+id,
        message: 'Are you sure to do this.',
        buttons: [
          {
            label: 'Yes',
            onClick: () => { 
              setDel(id);
            }
          },
          {
            label: 'No'
          }
        ]
      });
    }

    var con = 0;

    useEffect(() => {
      con++
      if(con === 1){
        const token = sessionStorage.getItem("token");
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
    
        const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };
    
        
        fetch(server+"/api/lang", requestOptions)
        .then(response => response.json())
        .then(result => {
          result.message ?
            setData([{
                "id":"",
                "name":"",
                "slug":""
            }])
            :
            setData(result);
        })
        .catch(error => console.log('error', error));
      }
    },[trash]);

    return(
      <Fragment>
        <Checklogin />
        <Delete type="lang" id={del} />
        <div className="container">
        <button className="btn btn_primary" id="new_content" type="button"><Link to="/language">New Language</Link></button>
            <table>
            <thead>
                <tr className="head_tr">
                    <td>ID</td>
                    <td>Name</td>
                    <td>Slug</td>
                </tr>
            </thead>
            <tbody>
               
                { 
                data.map((lang, index)  => (
                <Fragment key={index}>
                <tr>
                    <td>{lang.id}</td>
                    <td>{lang.name}</td>
                    <td>{lang.slug}</td>
                    <td>
                        <div className="pencil"><Link to={`/language/${lang.id}`}><FontAwesomeIcon  icon={faPencil} /></Link></div>
                        <div className="trash" onClick={() => submit(lang.id)}><FontAwesomeIcon  icon={faTrashCan} /></div>
                    </td>
                </tr>
                </Fragment> 
                     ))
                }
                
            </tbody>
            </table>
        </div>
      </Fragment>
      
    );
}

export default Languages;